// extracted by mini-css-extract-plugin
export default {"copyButton":"PlaygroundSharedStyles-module__copyButton__QVxhKOx"};